import React from 'react';
import { Button } from '@/components/ui/button';

import type { ProgramControlCommonProps, SubmitReportFn } from '../controlTypes';

type LeadReferralExportSite = { label: string; site: string | null };

type LeadProgramControlsProps = ProgramControlCommonProps & {
  leadReferralExportSites: LeadReferralExportSite[];
  onSubmitReport: SubmitReportFn;
};

export const LeadProgramControls = ({
  actionRowClass,
  renderStandardActionButtons,
  renderReportActionLabel,
  leadReferralExportSites,
  onSubmitReport,
}: LeadProgramControlsProps) => (
  <div className="mb-3 flex flex-wrap items-end justify-between gap-4 rounded-[var(--border-radius-medium)] border border-[var(--neutral-gray-40)] bg-white px-4 py-3">
    <div className="text-xs font-semibold uppercase tracking-wide text-[var(--neutral-gray-100)]">Referral exports</div>
    <div className={actionRowClass}>
      {renderStandardActionButtons()}
      {leadReferralExportSites.map(({ label, site }) => (
        <Button
          key={label}
          type="button"
          variant="outline"
          size="sm"
          className="h-8"
          onClick={() => {
            const reportFields: Record<string, string> = {
              action: 'all-report',
              download: '1',
            };

            if (site) {
              reportFields.site = site;
            }

            onSubmitReport(reportFields);
          }}
        >
          {renderReportActionLabel(label)}
        </Button>
      ))}
    </div>
  </div>
);
